import React from "react";
import TypographyInline from "../../../components/Typography/TypographyInline";
import CustomTooltip from "../../../components/Tooltip/CustomTooltip";
import { ERROR, GREY, NAVY, WARNING } from "../../../utils/constants/colors";
import { fontWeight } from "../../../utils/constants/UI";

const styles = {
  chip: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "3px",
    padding: "2px 8px",
    backgroundColor: NAVY.W_50,
    borderRadius: "6px",
    width: "fit-content",
    flexShrink: 0,
  },
};

// Keeps the chip narrow when counts grow large (1234 -> "1.2k").
// The tooltip always carries the exact numbers.
const formatCount = (value = 0) => {
  const num = Number(value) || 0;
  if (num >= 1000000) return `${(num / 1000000).toFixed(1).replace(/\.0$/, "")}m`;
  if (num >= 1000) return `${(num / 1000).toFixed(1).replace(/\.0$/, "")}k`;
  return `${num}`;
};

// Compact hard/soft bounce split shown inside the Total Bounces stat card.
// Hidden entirely while there is nothing to split (both counts 0).
const BounceSplitChip = ({ hard = 0, soft = 0 }) => {
  if (!(Number(hard) > 0 || Number(soft) > 0)) return null;

  return (
    <CustomTooltip title={`${hard} Hard & ${soft} Soft bounced`}>
      <div style={styles.chip}>
        <TypographyInline
          isNoWrap={true}
          size="xs"
          color={ERROR.W_500}
          fontWeight={fontWeight.SEMIBOLD}
          label={`${formatCount(hard)} H`}
        />
        <TypographyInline
          size="xs"
          color={GREY.TERTIARY}
          fontWeight={fontWeight.REGULAR}
          label="&"
        />
        <TypographyInline
          isNoWrap={true}
          size="xs"
          color={WARNING.W_600}
          fontWeight={fontWeight.SEMIBOLD}
          label={`${formatCount(soft)} S`}
        />
      </div>
    </CustomTooltip>
  );
};

export default BounceSplitChip;
